import { CareProviderSearchSidebar } from '@/components/molecules/CareProviderSearchSidebar/CareProviderSearchSidebar';
import { CareProviderSearchResults } from '@/components/molecules/CareProviderSearchResults/CareProviderSearchResults';
import { CareProviderRegulatorsBanner } from '@/components/molecules/CareProviderRegulatorsBanner/CareProviderRegulatorsBanner';

import Stack from '@mui/material/Stack';
import { sp } from '@/theme/mui';
import { Banner } from './Banner';

interface SearchResponse {
  location?: string;
  regulator?: string;
  items?: any[];
}

export interface DirectorySearchProps {
  results: SearchResponse;
  bannerImageUrl: string;
}
export const DirectorySearch = ({
  bannerImageUrl,
  results,
}: DirectorySearchProps) => {
  return (
    <Stack sx={{ height: '100%' }}>
      <Banner bannerImageUrl={bannerImageUrl} />
      <Stack
        direction='row'
        sx={{
          gap: sp[16],
          '@media (max-width: 768px)': { flexDirection: 'column' },
        }}
      >
        <CareProviderSearchSidebar isDisabled={false} />
        <CareProviderSearchResults results={results} />
      </Stack>
      <CareProviderRegulatorsBanner />
    </Stack>
  );
};

export default DirectorySearch;
